export enum SUBMITSION {
  REQURIED = '必要',
  NOT_REQUIRED = '不要'
}
